import "./App.css";
import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import checkIfTokenIsValid from "./utils/auth";
import { ReactKeycloakProvider } from "@react-keycloak/web";

// Component imports
import PandDetail from "./components/PandDetail/PandDetail";
import Footer from "./components/Footer/Footer";

// Page imports
import Home from "./pages/Home/Home";
import UserAttributes from "./pages/UserAttributesKeycloak/UserAttributes";
import PandenOverzicht from "./pages/PandenOverzicht/PandenOverzicht";
import OnderhoudstakenOverzicht from "./pages/OnderhoudstakenOverzicht/OnderhoudstakenOverzicht";
import Login from "./pages/Login/Login";
import KeycloakLogin from "./pages/KeycloakLogin/Keycloaklogin"
import PandEdit from "./pages/PandEdit/PandEdit";
import NotFound from "./pages/NotFound/NotFound";
import OnderhoudstaakEdit from "./pages/OnderhoudstaakEdit/OnderhoudstaakEdit";
import OnderhoudstaakToevoegen from "./pages/OnderhoudstaakToevoegen/OnderhoudstaakToevoegen";
import PandOnderhoudstakenEdit from "./pages/PandOnderhoudstakenEdit/PandOnderhoudstakenEdit";
import keycloak from "./keycloak";
import PrivateRoute from "./routes/PrivateRoute";

const App = () => {
  return (
    <div className="App">
      <ReactKeycloakProvider authClient={keycloak}> 
      <Router basename="/app">
        <Switch>
          {/* <Route exact path="/">{checkIfTokenIsValid ? <Home /> : <Redirect to="/login" />}</Route> */}
          {/* <Route exact path="/">{checkIfTokenIsValid ? <Home /> : <Redirect to="/keycloaklogin" />}</Route> */}
          <Route exact path="/" component={() => <Home />} />
          <Route exact path="/userattributes" component={()=> < UserAttributes/>} />
          <Route exact path="/panden" component={() => <PandenOverzicht />} />
          <Route exact path="/onderhoudstaken" component={() => <OnderhoudstakenOverzicht />} />
          <Route path="/onderhoudstaken/toevoegen" component={() => <OnderhoudstaakToevoegen />} />
          <Route path="/onderhoudstaken/:id/edit" component={() => <OnderhoudstaakEdit />}/>
          <Route exact path="/panden/:id" component={() => <PandDetail />} />
          <Route exact path="/panden/:id/edit" component={() => <PandEdit />} />
          <Route exact path="/panden/:id/onderhoudstaken/edit" component={() => <PandOnderhoudstakenEdit />} />
          <Route exact path="/login" component={() => <Login />} />
          <Route exact path="/keycloaklogin" component={() => <KeycloakLogin/>} />
          <Route path="/not-found" component={() => <NotFound />} />
        </Switch>
      </Router>
      </ReactKeycloakProvider>
      <Footer />
    </div>
  );
};

export default App;
